// extracted by mini-css-extract-plugin
module.exports = {"footer":"HomeFooter_footer__7lK6m"};